import { render, staticRenderFns } from "./d-activity-comment-activity.vue?vue&type=template&id=5f5ce468&"
import script from "./d-activity-comment-activity.vue?vue&type=script&lang=js&"
export * from "./d-activity-comment-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports